import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { useGetTerminatedBusinessUnitWorkersQuery } from '@xemplo/lookups-query';
import { useListBuilder } from '@xemplo/stateful-list-core';
import { V3 } from '@xemplo/text-dropdown-multi';

import { FormFields } from '../../../create-amendment.types';

export const TerminatedWorkers = () => {
  const { control } = useFormContext<FormFields>();

  const businessUnit = useWatch({ control, name: 'businessUnit' });
  const appliesTo = useWatch({ control, name: 'appliesTo' });

  const { data, isLoading } = useGetTerminatedBusinessUnitWorkersQuery({
    id: businessUnit ?? null,
    requestParams: { per_page: 0 },
  });

  const formattedData = useMemo(() => {
    if (!data) return [];

    return (
      data?.result?.rows.map((item) => ({
        key: item.employeeId,
        value: `${item.firstName} ${item.lastName}`,
      })) ?? []
    );
  }, [data]);

  const terminatedWorkersList = useListBuilder(formattedData);

  return (
    <V3.TextDropdownMultiRhf
      items={terminatedWorkersList}
      data-testid="terminatedWorkers"
      name="terminatedWorkers"
      placeholder="Terminated worker(s)"
      aria-label="Terminated worker(s)"
      disabled={isLoading || !formattedData.length}
      rules={{
        required: appliesTo?.length ? false : 'This field is required',
      }}
    />
  );
};
